export const LabelInput = ({
  htmlFor,
  title,
  style,
  className,
}: {
  htmlFor: string;
  title: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  return (
    <label
      htmlFor={htmlFor}
      style={{ display: 'block', marginBottom: 8, ...style }}
      className={`text-sm text-[hsl(var(--card-foreground))] ${className}`}
    >
      {title}
    </label>
  );
};

export default LabelInput;
